import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

export const Root = styled.div`
    position: relative;

    [contenteditable] {
        outline: none;
    }

    div,
    figure {
        margin: 0;
    }
`;

export const Toolbar = styled.div`
    position: absolute;
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 1px;
    display: flex;
    z-index: 13000;
`;

const ellipsisKeyframes = keyframes`
    to {
        width: 37px;
    }
`;

export const Editor = styled.div`
    a {
        color: var(--ty-palette-primary-main, #1976d2);
        text-decoration: underline;
        cursor: pointer;
    }

    &.empty {
        &:before {
            content: attr(data-placeholder);
            color: #999;
            pointer-events: none;
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    &.loading {
        &:after {
            display: inline-block;
            white-space: nowrap;
            color: #999;
            overflow: hidden;
            vertical-align: bottom;
            animation: ${ellipsisKeyframes} steps(12, end) 1s infinite;
            content: '\\2026\\2026\\2026\\2026';
            width: 0;
        }
    }
`;
